import { render, staticRenderFns } from "./VacanciesDetails.vue?vue&type=template&id=08fc9ec8&scoped=true"
import script from "./VacanciesDetails.vue?vue&type=script&lang=js"
export * from "./VacanciesDetails.vue?vue&type=script&lang=js"
import style0 from "./VacanciesDetails.vue?vue&type=style&index=0&id=08fc9ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc9ec8",
  null
  
)

export default component.exports